export const usePaginate = () => {
    return (list = [], pagination = { page: 1, size: 10 }) => {
        const { page, size } = pagination;
        const total = list.length;
        const start = (page - 1) * size;
        const end = start + size;
        const records = list.slice(start, end);
        return {
            page,
            size,
            total,
            records
        };
    };
};
